/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class CreateFabricTableShortcutDemoRequestShortcutsInner {
  /**
  * The name of the Fabric table shortcut
  */
  'name': string;
  /**
  * The resource identifier
  */
  'resourceId': string;
  /**
  * (Optional) The vault identifier - not used when bucket_name/bucket_region are in feature flag
  */
  'vaultId'?: string;
  /**
  * (Optional) The snapshot identifier - will use value from feature flag if configured
  */
  'snapshotId'?: string;
  /**
  * The table name
  */
  'tableName': string;
  /**
  * The database name
  */
  'dbName': string;
  /**
  * The schema name
  */
  'schemaName': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "resourceId",
      "baseName": "resource_id",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "vaultId",
      "baseName": "vault_id",
      "type": "string",
      "format": ""
    },
    {
      "name": "snapshotId",
      "baseName": "snapshot_id",
      "type": "string",
      "format": ""
    },
    {
      "name": "tableName",
      "baseName": "table_name",
      "type": "string",
      "format": ""
    },
    {
      "name": "dbName",
      "baseName": "db_name",
      "type": "string",
      "format": ""
    },
    {
      "name": "schemaName",
      "baseName": "schema_name",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CreateFabricTableShortcutDemoRequestShortcutsInner.attributeTypeMap;
  }

  public constructor() {
  }
}

